import { RequestParamsController } from "../../../common/scripts/request_params_controller";

/*
  * コンポーネント設定情報取得処理用リクエストデータ生成処理。
  * @param {signalMappingComponent} self
  * @param {string} userID
  * @returns リクエストデータ
  */

export class RequestParamsMaker {
  public static makeGetSignallampComponentSettingDataParams(
    signallampID: number,
    userID: string,
  ) {
    const data = {
      user_id: userID,
      signallamp_id: signallampID,
    };
    return RequestParamsController.create(
      "post",
      "getMstSignallampComponentSetting",
      data,
    );
  }

  public static makeGetBackgroundImageParams(
    userID: string,
  ) {
    const data = {
      user_id: userID
    };
    return RequestParamsController.create(
      "post",
      "getSignallampMappingBackgroundImage",
      data,
    );
  }
  public static makeUploadImageParams(
    userID: string,
    imageBinary: any
  ) {
    const data = {
      user_id: userID,
      image_binary: imageBinary
    };
    return RequestParamsController.create(
      "post",
      "updateSignallampMappingBackgroundImage",
      data,
    );
  }
}
